import teaserImg from './image';
import teaserContent from './content';

/**
 * @param {Object} customizedAssets - customized content assets assigned to promo tile or promo row.
 * @returns {string} teaser wrapper block HTML
 */
export default customizedAssets => {
    if (!customizedAssets) {
        return '';
    }
    return customizedAssets
        .map(asset => {
            let {teaserBoxTextColor} = asset;
            const {teaserBoxColor, teaserImage} = asset;

            // Special font color handling for white font color with transparent (not set) background color.
            if (
                (teaserBoxTextColor && teaserBoxTextColor === 'white' && !teaserBoxColor) ||
                teaserBoxColor === '#ffffff' ||
                teaserBoxColor === '#fff' ||
                teaserBoxColor === 'white'
            ) {
                teaserBoxTextColor = 'white-black';
            }

            const backgroundStyle = teaserBoxColor ? `style="background-color:${teaserBoxColor}` : '';
            const contentExist = asset.teaserHeadline || asset.teaserSubHeadline || asset.teaserLinkTarget;

            return `
                <div data-teaser-name='${asset.teaserTrackingId || ''}' class='teaser-wrapper-inner ContentAssetID-${
                asset.id
            }'>
                    ${teaserImg(teaserImage)}
                    ${contentExist ? teaserContent(asset, teaserBoxTextColor || '', backgroundStyle || '') : ''}
                </div>
            `;
        })
        .join('');
};
